import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { CookieConsentUserSettingsPage } from './CookieConsentUserSettingsPage'

export const CookieConsentUserSettingsPageRegistration =
    createRegisterableComponent('cookie-consent-user-settings-page', () => (
        <CookieConsentUserSettingsPage />
    ))
